
<template>
  <div>
    <el-form
      ref="entityData"
      :model="entityData"
      :rules="rules"
      label-width="100px"
      class="demo-ruleForm"
      label-position="right"
    >
      <el-row :gutter="20">

        <!-- 专著名称 -->
        <el-col :span="12">
          <el-form-item
            prop="zhuanZhuMingCheng"
            label="专著名称"
          >
            <el-input
              v-model="entityData.zhuanZhuMingCheng"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 类别 -->

        <el-col :span="12">
          <el-form-item
            prop="leiBieDictKey"
            label="类别"
          >
            <Combox
              v-model="entityData.leiBieDictKey"
              type-id="D23"
              :option-data="getComboxData('D23')"
              :add-client="true"
            />
          </el-form-item>
        </el-col>

        <!-- 参与角色 -->

        <el-col :span="12">
          <el-form-item
            prop="canYuJueSeDictKey"
            label="参与角色"
          >
            <Combox
              v-model="entityData.canYuJueSeDictKey"
              type-id="D24"
              :option-data="getComboxData('D24')"
              :add-client="true"
            />
          </el-form-item>
        </el-col>

        <!-- 编写章节 -->

        <el-col :span="12">
          <el-form-item
            prop="bianXieZhangJie"
            label="编写章节"
          >
            <el-input
              v-model="entityData.bianXieZhangJie"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 起止页 -->

        <el-col :span="12">
          <el-form-item
            prop="qiZhiYe"
            label="起止页"
          >
            <el-input
              v-model="entityData.qiZhiYe"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 编写字数 -->

        <el-col :span="12">
          <el-form-item
            prop="bianXieZhiShu"
            label="编写字数"
          >
            <el-input
              v-model="entityData.bianXieZhiShu"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 主编姓名 -->

        <el-col :span="12">
          <el-form-item
            prop="zhuBianXingMing"
            label="主编姓名"
          >
            <el-input
              v-model="entityData.zhuBianXingMing"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 版次 -->

        <el-col :span="12">
          <el-form-item
            prop="banCi"
            label="版次"
          >
            <el-input
              v-model="entityData.banCi"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 出版社 -->

        <el-col :span="12">
          <el-form-item
            prop="chuBanShe"
            label="出版社"
          >
            <el-input
              v-model="entityData.chuBanShe"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 出版日期 -->
        <el-col :span="12">
          <el-form-item
            prop="chuBanRiQi"
            label="出版日期"
          >
            <el-date-picker
              v-model="entityData.chuBanRiQi"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 100%;"
            />
          </el-form-item>
        </el-col>

        <!-- 总字数 -->

        <el-col :span="12">
          <el-form-item
            prop="zongZhiShu"
            label="总字数"
          >
            <el-input
              v-model="entityData.zongZhiShu"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 专业 -->

        <el-col :span="12">
          <el-form-item
            prop="zhuanYe"
            label="专业"
          >
            <el-input
              v-model="entityData.zhuanYe"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 并列书名 -->

        <el-col :span="12">
          <el-form-item
            prop="bingLieShuMing"
            label="并列书名"
          >
            <el-input
              v-model="entityData.bingLieShuMing"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 其他书名信息 -->

        <el-col :span="12">
          <el-form-item
            prop="qiTaShuMingXinXi"
            label="其他书名信息"
          >
            <el-input
              v-model="entityData.qiTaShuMingXinXi"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 其他编者 -->

        <el-col :span="12">
          <el-form-item
            prop="qiTaBianZhe"
            label="其他编者"
          >
            <el-input
              v-model="entityData.qiTaBianZhe"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 正从书名 -->

        <el-col :span="12">
          <el-form-item
            prop="zhengCongShuMing"
            label="正从书名"
          >
            <el-input
              v-model="entityData.zhengCongShuMing"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 丛书主编 -->

        <el-col :span="12">
          <el-form-item
            prop="congShuZhuBian"
            label="丛书主编"
          >
            <el-input
              v-model="entityData.congShuZhuBian"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 出版资金资助 -->

        <el-col :span="12">
          <el-form-item
            prop="chuBanZiJinZiZhu"
            label="出版资金资助"
          >
            <el-input
              v-model="entityData.chuBanZiJinZiZhu"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 印次 -->

        <el-col :span="12">
          <el-form-item
            prop="yinCi"
            label="印次"
          >
            <el-input-number
              v-model="entityData.yinCi"
            />
          </el-form-item>
        </el-col>

        <!-- 印数 -->

        <el-col :span="12">
          <el-form-item
            prop="yinShu"
            label="印数"
          >
            <el-input-number
              v-model="entityData.yinShu"
            />
          </el-form-item>
        </el-col>

        <!-- ISSN -->

        <el-col :span="12">
          <el-form-item
            prop="issn"
            label="ISSN"
          >
            <el-input
              v-model="entityData.issn"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- ISSC -->

        <el-col :span="12">
          <el-form-item
            prop="issc"
            label="ISSC"
          >
            <el-input
              v-model="entityData.issc"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 发行范围 -->

        <el-col :span="12">
          <el-form-item
            prop="faXingFanWei"
            label="发行范围"
          >
            <el-input
              v-model="entityData.faXingFanWei"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 助理 -->
        <el-col :span="12">
          <el-form-item
            prop="assitantList"
            label="助理"
          >
            <AssistEditForm
              v-model="entityData.assitantList"
              module-code="jx02"
            />
          </el-form-item>
        </el-col>

      </el-row>
    </el-form>
    <div class="dialog-footer">
      <el-button
        v-if="ketiInfo.isFuzeren || ketiInfo.isZuli"
        type="primary"
        @click="handleSave()"
      >
        保  存
      </el-button>
    </div>
  </div>
</template>
<script>
import pathReq from '@/api/pathlist'
import Combox from '@/views/managesystem/gz/com/Combox'
import AssistEditForm from '@/views/managesystem/gz/com/AssistEditForm.vue'
export default {
  components: {
    Combox, AssistEditForm
  },
  props: {
    // postId: { type: Number, default: null }
  },
  data() {
    return {
      entityId: null,
      entityData: {},
      allComboxData: [],
      rules: {
        zhuanZhuMingCheng: [
          { required: true, message: '请输入专著名称', trigger: 'change,blur' }
        ]
      },
      selectedValue: [],
      ketiInfo: {}
    }
  },
  computed: {},
  created() {
    /** 下拉框数据 */
    pathReq.getComboxDatasByIdArray('D23;D24').then(res => {
      this.allComboxData = res.data.result
    })
  },
  activated() {
    this.init()
  },
  methods: {
    // combox筛选值
    getComboxData(typeId) {
      return this.allComboxData.filter(function(item) {
        return item.typeId === typeId
      })
    },
    /**
     * 初始化数据
     */
    init() {
      this.entityId = this.$route.params.id
      if (!this.entityId) {
        this.$router.go(-1)
        return
      }
      const path = '/api/services/app/jx04/GetEditjx04?Id=' + this.entityId
      pathReq.getNoParams(path).then(res => {
        this.entityData = res.data.result.entityData
      }).then(_ => {
        pathReq.getKetiInfo('jx04', this.entityData.id).then(r => {
          this.ketiInfo = r.data.result
        })
      })
    },
    /**
     * 打开数据字典弹出框
     */
    handleAddComboxData(dictTypeId, dictTypeName) {
      this.$bus.emit('comboxData', dictTypeId, dictTypeName)
    },
    /**
     * 新增或者修改身份信息数据
     */
    handleSave() {
      this.$refs['entityData'].validate(valid => {
        if (valid) {
          const that = this
          const path = '/api/services/app/jx04/CreateOrUpdatejx04'

          pathReq
            .postForm(path, { entityData: that.entityData })
            .then(res => {
              that.$message.success('保存成功')
            })
        }
      })
    }
  }
}
</script>
<style scoped>
.el-dialog__body {
  padding-top: 10px !important;
}

.dialog-footer {
  text-align: right;
}

.el-select {
  margin-right: 8px;
  width: 84% !important;
}
</style>
